import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IGetCategoriesShortResponse, IGetCategoriesShort } from 'types';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { useTranslation } from 'react-i18next';
import {
	ChangeSubCategoryPositionContext,
	IChangeSubCategoryPositionContext,
} from '../../../../../changeSubCategoryPositionState/changeSubCategoryPositionContext';
import { getCategoriesShortInfo } from 'backend/categories';
import style from './CategorySelect.module.scss';

const { Option } = Select;

const CategorySelect: React.FC = () => {
	const { setIDCategory, selectedRestaurant, IDSelectedCategory } = useContext<IChangeSubCategoryPositionContext>(
		ChangeSubCategoryPositionContext,
	);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(selectedRestaurant ? getCategoriesShortInfo : null, { restaurantIds: [selectedRestaurant?.id || ''] });
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [selectedRestaurant]);

	return (
		<div className={style.container}>
			<Text translationNameSpace="listing" translationKey="categoryLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDCategory}
				value={IDSelectedCategory}
				loading={loading}
				listItemHeight={response?.data.categories.length}
				allowClear={true}
				disabled={!selectedRestaurant || loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.categories.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response?.data.categories.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								{el.name}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default CategorySelect;
